import { render, staticRenderFns } from "./ChoiceStepDocument.vue?vue&type=template&id=20694867&"
import script from "./ChoiceStepDocument.vue?vue&type=script&lang=js&"
export * from "./ChoiceStepDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20694867')) {
      api.createRecord('20694867', component.options)
    } else {
      api.reload('20694867', component.options)
    }
    module.hot.accept("./ChoiceStepDocument.vue?vue&type=template&id=20694867&", function () {
      api.rerender('20694867', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/document-package/components/ChoiceStepDocument.vue"
export default component.exports